var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.ListView-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M15.5,0H4.8C4.5,0,4.3,0.2,4.3,0.5v2.1c0,0.3,0.2,0.5,0.5,0.5h10.7C15.8,3.2,16,3,16,2.7V0.5 C16,0.2,15.8,0,15.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M15.5,6.4H4.8c-0.3,0-0.5,0.2-0.5,0.5v2.1c0,0.3,0.2,0.5,0.5,0.5h10.7c0.3,0,0.5-0.2,0.5-0.5V6.9 C16,6.7,15.8,6.4,15.5,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M15.5,12.8H4.8c-0.3,0-0.5,0.2-0.5,0.5v2.1c0,0.3,0.2,0.5,0.5,0.5h10.7c0.3,0,0.5-0.2,0.5-0.5v-2.1 C16,13.1,15.8,12.8,15.5,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M2.7,0H0.5C0.2,0,0,0.2,0,0.5v2.1C0,3,0.2,3.2,0.5,3.2h2.1C3,3.2,3.2,3,3.2,2.7V0.5C3.2,0.2,3,0,2.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M2.7,6.4H0.5C0.2,6.4,0,6.7,0,6.9v2.1c0,0.3,0.2,0.5,0.5,0.5h2.1c0.3,0,0.5-0.2,0.5-0.5V6.9 C3.2,6.7,3,6.4,2.7,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ListView-st0",
    d: "M2.7,12.8H0.5c-0.3,0-0.5,0.2-0.5,0.5v2.1C0,15.8,0.2,16,0.5,16h2.1c0.3,0,0.5-0.2,0.5-0.5v-2.1 C3.2,13.1,3,12.8,2.7,12.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListView);
export default __webpack_public_path__ + "static/media/ListView.35bed77bb1aa3e8fc366a4fa39f0e1d4.svg";
export { ForwardRef as ReactComponent };